<template>
  <div class="page">
    <PageHeader title="Settings" :description="currentWorkspace.name" :tabs="tabs" />
    <router-view />
  </div>
</template>

<script lang="ts" setup>
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { TabItem } from '@/shared/components/pageHeader/tabItem';
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const tabs: TabItem[] = [
  { name: 'General', route: 'general-settings' },
  { name: 'Teammates', route: 'teammates' },
  { name: 'Email', route: 'email' },
  { name: 'Business Hours', route: 'business-hours' },
  { name: 'Contact Attributes', route: 'contact-attributes' },
];
</script>
